@if (captionVisible) {
  <ldw-vmp-label [vmp]="vmp" [style]="getItemWidth()"></ldw-vmp-label>
}
<ng-content select=".inner-control"></ng-content>
<!--
<div class="errorMessage" *ngIf="!isValid">{{question.label}} is required</div>
-->
